import React, { useContext, useState, useRef } from "react";
import CX from "classnames";
import {
  PluginContext,
  InsertContext,
  DrawPageStateContext,
  GlobalStoreContext,
} from "@/context";
// import initPlugins from '@MainPage/plugins'
import "./index.less";

// TODO: 根据用户信息初始化modules, 判断用户能使用哪些module

export default function LeftContent() {
  const { isLogin, currentTab, setCurrentTab } = useContext(GlobalStoreContext);
  const { plugins, setPlugins } = useContext(PluginContext);
  const { setCurrentModule } = useContext(DrawPageStateContext);
  const { init } = useContext(InsertContext);
  const [dropTitle, setDropTitle] = useState("请选择模块");

  return (
    <div className="left-content-wrap">
      <div className="main-content">
        <div
          className={CX({
            select: true,
            active: currentTab === 0,
          })}
          onClick={() => {
            setCurrentTab(0);
          }}
        >
          <div>账号设置</div>
        </div>
        <div
          className={CX({
            select: true,
            active: currentTab === 1,
          })}
          onClick={() => {
            setCurrentTab(1);
          }}
        >
          <div>用户账号注册</div>
        </div>
        <div
          className={CX({
            select: true,
            active: currentTab === 2,
          })}
          onClick={() => {
            setCurrentTab(2);
          }}
        >
          <div>用户账号管理</div>
        </div>
        <div
          className={CX({
            select: true,
            active: currentTab === 3,
          })}
          onClick={() => {
            setCurrentTab(3);
          }}
        >
          <div>模块管理</div>
        </div>
        <div
          className={CX({
            select: true,
            active: currentTab === 4,
          })}
          onClick={() => {
            setCurrentTab(4);
          }}
        >
          <div>广告位配置</div>
        </div>
      </div>
    </div>
  );
}
